<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper dq-platform">
    <div class="content">
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="input-icon mb-2 position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input
              ref="dateRangeInput"
              type="text"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              readonly
            />
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="dq-cmd-brief">
        <div class="dq-cmd-brief__bg" aria-hidden="true">
          <img
            src="@/assets/img/bg/welcome-bg-02.svg"
            alt=""
            class="welcome-bg-01"
          />
          <img
            src="@/assets/img/bg/welcome-bg-03.svg"
            alt=""
            class="welcome-bg-02"
          />
          <img
            src="@/assets/img/bg/welcome-bg-01.svg"
            alt=""
            class="welcome-bg-03"
          />
        </div>
        <div class="dq-cmd-brief__inner">
          <div>
            <span class="dq-cmd-brief__kicker">
              <i class="ti ti-shield-check"></i>
              Platform command center
            </span>
            <h2>Welcome back, {{ currentUserName || "Super Admin" }}</h2>
            <p class="dq-cmd-brief__copy">
              <strong>{{ kpis.new_subscriptions_today || 0 }}</strong>
              new companies subscribed today. Review the queue, then drill into
              companies, billing, and plans.
            </p>
          </div>
          <div class="dq-cmd-brief__actions">
            <router-link
              to="/super-admin/companies"
              class="btn btn-dark btn-md"
            >
              Companies
            </router-link>
            <router-link
              to="/super-admin/packages"
              class="btn btn-light btn-md"
            >
              All Packages
            </router-link>
            <router-link
              to="/super-admin/purchase-transaction"
              class="dq-cmd-brief__link"
            >
              Transactions
            </router-link>
            <router-link
              to="/super-admin/subscription"
              class="dq-cmd-brief__link"
            >
              Subscriptions
            </router-link>
            <router-link
              to="/super-admin/demo-requests"
              class="dq-cmd-brief__link"
            >
              Demo requests
            </router-link>
          </div>
        </div>
        <div class="dq-cmd-brief__stats">
          <router-link
            to="/super-admin/purchase-transaction"
            class="dq-cmd-brief__stat"
          >
            <span class="dq-cmd-brief__stat-value">{{ pendingReviewCount }}</span>
            <span class="dq-cmd-brief__stat-label">Payments to review</span>
          </router-link>
          <router-link
            to="/super-admin/subscription"
            class="dq-cmd-brief__stat"
          >
            <span class="dq-cmd-brief__stat-value">{{ renewalCount }}</span>
            <span class="dq-cmd-brief__stat-label">Renewals / grace</span>
          </router-link>
          <div class="dq-cmd-brief__stat">
            <span class="dq-cmd-brief__stat-value">{{ expiredCount }}</span>
            <span class="dq-cmd-brief__stat-label">Plans expired</span>
          </div>
          <router-link
            to="/super-admin/demo-requests"
            class="dq-cmd-brief__stat"
          >
            <span class="dq-cmd-brief__stat-value">{{ demoCount }}</span>
            <span class="dq-cmd-brief__stat-label">Demo requests</span>
          </router-link>
        </div>
      </div>

      <div v-if="dashboard.loading" class="dq-cmd-skeleton" aria-hidden="true">
        <div class="dq-cmd-skeleton__hero"></div>
        <div class="dq-cmd-skeleton__row">
          <div class="dq-cmd-skeleton__tile"></div>
          <div class="dq-cmd-skeleton__tile"></div>
          <div class="dq-cmd-skeleton__tile"></div>
          <div class="dq-cmd-skeleton__tile"></div>
          <div class="dq-cmd-skeleton__tile"></div>
        </div>
        <span class="visually-hidden">Loading dashboard...</span>
      </div>

      <div class="row dq-stat-grid" v-show="!dashboard.loading">
        <div class="col-xl col-sm-6 d-flex">
          <div class="card flex-fill dq-cmd-tile">
            <div class="card-body">
              <div class="dq-cmd-tile__top">
                <span class="dq-cmd-tile__icon">
                  <i class="ti ti-building fs-16"></i>
                </span>
                <span
                  class="badge fw-normal"
                  :class="
                    kpis.total_companies_change_pct >= 0
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{ formatPercent(kpis.total_companies_change_pct) }}
                </span>
              </div>
              <div class="dq-cmd-tile__main">
                <div>
                  <h2>{{ kpis.total_companies ?? 0 }}</h2>
                  <p>Total Companies</p>
                </div>
                <div class="dq-cmd-tile__spark" id="total-chart">
                  <apexchart
                    type="bar"
                    width="70"
                    height="36"
                    :options="totalChart.total"
                    :series="totalChart.series"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl col-sm-6 d-flex">
          <div class="card flex-fill dq-cmd-tile">
            <div class="card-body">
              <div class="dq-cmd-tile__top">
                <span class="dq-cmd-tile__icon">
                  <i class="ti ti-carousel-vertical fs-16"></i>
                </span>
                <span class="badge bg-success fw-normal">
                  {{ formatPercent(kpis.active_companies_change_pct) }}
                </span>
              </div>
              <div class="dq-cmd-tile__main">
                <div>
                  <h2>{{ kpis.active_companies ?? 0 }}</h2>
                  <p>Active Companies</p>
                </div>
                <div class="dq-cmd-tile__spark" id="active-chart">
                  <apexchart
                    type="area"
                    width="70"
                    height="36"
                    :options="activeChart.active"
                    :series="activeChart.series"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl col-sm-6 d-flex">
          <div class="card flex-fill dq-cmd-tile">
            <div class="card-body">
              <div class="dq-cmd-tile__top">
                <span class="dq-cmd-tile__icon">
                  <i class="ti ti-users fs-16"></i>
                </span>
                <span
                  class="badge fw-normal"
                  :class="
                    kpis.subscribers_change_pct >= 0
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{ formatPercent(kpis.subscribers_change_pct) }}
                </span>
              </div>
              <div class="dq-cmd-tile__main">
                <div>
                  <h2>{{ kpis.total_subscribers ?? 0 }}</h2>
                  <p>Total Subscribers</p>
                </div>
                <div class="dq-cmd-tile__spark" id="inactive-chart">
                  <apexchart
                    type="area"
                    width="70"
                    height="36"
                    :options="inactiveChart.inactive"
                    :series="inactiveChart.series"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl col-sm-6 d-flex">
          <div class="card flex-fill dq-cmd-tile">
            <div class="card-body">
              <div class="dq-cmd-tile__top">
                <span class="dq-cmd-tile__icon">
                  <i class="ti ti-businessplan fs-16"></i>
                </span>
                <span
                  class="badge fw-normal"
                  :class="
                    kpis.earnings_change_pct >= 0 ? 'bg-success' : 'bg-danger'
                  "
                >
                  {{ formatPercent(kpis.earnings_change_pct) }}
                </span>
              </div>
              <div class="dq-cmd-tile__main">
                <div>
                  <h2>{{ formatCurrency(kpis.total_earnings) }}</h2>
                  <p>Paid Revenue</p>
                </div>
                <div class="dq-cmd-tile__spark" id="location-chart">
                  <apexchart
                    type="area"
                    width="70"
                    height="36"
                    :options="locationChart.location"
                    :series="locationChart.series"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl col-sm-6 d-flex">
          <div class="card flex-fill dq-cmd-tile">
            <div class="card-body">
              <div class="dq-cmd-tile__top">
                <span class="dq-cmd-tile__icon">
                  <i class="ti ti-clock-hour-4 fs-16"></i>
                </span>
                <span class="badge bg-warning fw-normal">Pending</span>
              </div>
              <div class="dq-cmd-tile__main">
                <div>
                  <h2>{{ formatCurrency(kpis.pending_collections) }}</h2>
                  <p>Pending Collections</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!dashboard.loading">
        <div class="col-xxl-3 col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-queue">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Payments to review</h5>
              <router-link
                to="/super-admin/purchase-transaction"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body">
              <div
                v-if="!lists.pending_reviews?.length"
                class="dq-cmd-empty"
              >
                Nothing needs review
              </div>
              <div v-else class="dq-cmd-queue__list">
                <div
                  v-for="item in lists.pending_reviews"
                  :key="`review-${item.id}`"
                  class="dq-cmd-item dq-cmd-item--warning"
                >
                  <div class="dq-cmd-item__body">
                    <h6 class="dq-cmd-item__title">
                      {{ item.company || "Unknown" }}
                    </h6>
                    <p class="dq-cmd-item__meta">
                      {{ item.invoice_no }} · {{ item.payment_status }}
                    </p>
                  </div>
                  <div class="dq-cmd-item__side">
                    <router-link
                      to="/super-admin/purchase-transaction"
                      class="link-warning fs-13 fw-semibold"
                    >
                      Review
                    </router-link>
                    <p class="dq-cmd-item__meta">
                      {{ item.currency }}
                      {{ Number(item.amount || 0).toLocaleString() }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-3 col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-queue">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Renewals / grace</h5>
              <router-link
                to="/super-admin/subscription"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body">
              <div
                v-if="!lists.renewal_requests?.length"
                class="dq-cmd-empty"
              >
                No renewals in the next 14 days
              </div>
              <div v-else class="dq-cmd-queue__list">
                <div
                  v-for="item in lists.renewal_requests"
                  :key="`renewal-${item.id}`"
                  class="dq-cmd-item dq-cmd-item--info"
                >
                  <div class="dq-cmd-item__body">
                    <h6 class="dq-cmd-item__title">
                      {{ item.company || "Unknown" }}
                    </h6>
                    <p class="dq-cmd-item__meta">
                      {{ item.status }} · Due {{ item.ends_at || "-" }}
                    </p>
                  </div>
                  <div class="dq-cmd-item__side">
                    <router-link
                      to="/super-admin/subscription"
                      class="link-info fs-13 fw-semibold"
                    >
                      Open
                    </router-link>
                    <p class="dq-cmd-item__meta">
                      {{ item.plan_name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-3 col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-queue">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Expired plans</h5>
              <router-link
                to="/super-admin/subscription"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body">
              <div
                v-if="!lists.recent_expired?.length"
                class="dq-cmd-empty"
              >
                No expired plans in this range
              </div>
              <div v-else class="dq-cmd-queue__list">
                <div
                  v-for="exp in lists.recent_expired"
                  :key="exp.id"
                  class="dq-cmd-item dq-cmd-item--danger"
                >
                  <div class="dq-cmd-item__body">
                    <h6 class="dq-cmd-item__title">
                      {{ exp.company || "Unknown" }}
                    </h6>
                    <p class="dq-cmd-item__meta">
                      Expired {{ exp.expired_at }}
                    </p>
                  </div>
                  <div class="dq-cmd-item__side">
                    <a
                      href="javascript:void(0);"
                      class="link-info fs-13 fw-semibold"
                      @click="sendReminder(exp.id)"
                    >
                      Email renewal notice
                    </a>
                    <p class="dq-cmd-item__meta">
                      {{ exp.plan_name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-3 col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-queue">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Demo requests</h5>
              <router-link
                to="/super-admin/demo-requests"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body">
              <div
                v-if="!lists.demo_requests?.length"
                class="dq-cmd-empty"
              >
                No demo requests waiting
              </div>
              <div v-else class="dq-cmd-queue__list">
                <div
                  v-for="item in lists.demo_requests"
                  :key="`demo-${item.id}`"
                  class="dq-cmd-item"
                >
                  <div class="dq-cmd-item__body">
                    <h6 class="dq-cmd-item__title">
                      {{ item.full_name }} · {{ item.company_name }}
                    </h6>
                    <p class="dq-cmd-item__meta">
                      {{ item.preferred_date }} {{ item.preferred_time }}
                    </p>
                  </div>
                  <div class="dq-cmd-item__side">
                    <router-link
                      to="/super-admin/demo-requests"
                      class="link-primary fs-13 fw-semibold"
                    >
                      Open
                    </router-link>
                    <p class="dq-cmd-item__meta">{{ item.email }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!dashboard.loading">
        <div class="col-xxl-3 col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-chart">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Companies</h5>
              <div class="dropdown mb-0">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>
                  {{ rangeLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('month')"
                      >This Month</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('week')"
                      >This Week</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('today')"
                      >Today</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <div id="company-chart">
                <apexchart
                  type="bar"
                  height="240"
                  :options="companyChart.company"
                  :series="companyChart.series"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 d-flex">
          <div class="card flex-fill dq-cmd-chart">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Revenue</h5>
              <div class="dropdown mb-0">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i
                  >{{ dashboard.filters.year }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li v-for="y in yearOptions" :key="y">
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeYear(y)"
                      >{{ y }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body pb-0">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap mb-2"
              >
                <div>
                  <h5 class="mb-1">
                    {{ formatCurrency(totalRevenueForYear) }}
                  </h5>
                  <p class="fs-13 text-gray-9 mb-0">
                    Refunded:
                    <span class="text-danger fw-semibold">
                      {{ formatCurrency(totalRefundsForYear) }}
                    </span>
                    <span class="mx-2">•</span>
                    Pending:
                    <span class="text-warning fw-semibold">
                      {{ formatCurrency(kpis.pending_collections || 0) }}
                    </span>
                  </p>
                </div>
                <p class="fs-13 text-gray-9 d-flex align-items-center mb-0">
                  <i class="ti ti-circle-filled me-1 fs-6 text-primary"></i>
                  Paid
                  <span class="mx-2">•</span>
                  <i class="ti ti-circle-filled me-1 fs-6 text-danger"></i>
                  Refunds
                </p>
              </div>
              <div id="revenue-income">
                <apexchart
                  type="bar"
                  height="230"
                  :options="revenueCharts.income"
                  :series="revenueCharts.series"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-3 col-xl-12 d-flex">
          <div class="card flex-fill dq-cmd-chart">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Top Plans</h5>
              <div class="dropdown mb-0">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>{{ rangeLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('month')"
                      >This Month</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('week')"
                      >This Week</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="changeRange('today')"
                      >Today</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <div id="plan-overview">
                <apexchart
                  type="donut"
                  height="240"
                  :options="donutChart.donut"
                  :series="donutChart.series"
                />
              </div>

              <div
                v-if="!planBreakdownDisplay.length"
                class="dq-cmd-empty mt-2"
              >
                No plan mix for this range
              </div>
              <div
                v-for="plan in planBreakdownDisplay"
                :key="plan.label"
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <p class="f-13 mb-0">
                  <i
                    class="ti ti-circle-filled me-1"
                    :class="plan.colorClass"
                  ></i>
                  {{ plan.label }}
                </p>
                <p class="f-13 fw-medium text-gray-9 mb-0">{{ plan.percent }}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!dashboard.loading">
        <div class="col-xxl-4 col-xl-12 d-flex">
          <div class="card flex-fill">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Recent Transactions</h5>
              <router-link
                to="/super-admin/purchase-transaction"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body pb-2">
              <div
                v-if="!lists.recent_transactions?.length"
                class="dq-cmd-empty"
              >
                No transactions in this range
              </div>
              <div
                v-for="trx in lists.recent_transactions"
                :key="trx.id"
                class="dq-cmd-item dq-cmd-item--success mb-2"
              >
                <div class="dq-cmd-item__body d-flex align-items-center">
                  <div
                    class="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center me-2"
                  >
                    <i class="ti ti-building"></i>
                  </div>
                  <div class="min-width-0">
                    <h6 class="dq-cmd-item__title">
                      {{ trx.company || "Unknown Company" }}
                    </h6>
                    <p class="dq-cmd-item__meta">
                      <span class="text-info">{{ trx.invoice_no }}</span>
                      · {{ trx.paid_at }}
                    </p>
                  </div>
                </div>
                <div class="dq-cmd-item__side">
                  <h6 class="mb-1">
                    +{{ trx.currency }} {{ trx.amount.toLocaleString() }}
                  </h6>
                  <p class="dq-cmd-item__meta mb-1">
                    {{ trx.plan_name }} ({{ trx.billing || "N/A" }})
                  </p>
                  <span
                    class="dq-cmd-chip"
                    :class="paymentChipClass(trx.payment_status)"
                  >
                    {{ trx.payment_status || "unknown" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-4 col-xl-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Recently Registered</h5>
              <router-link
                to="/super-admin/companies"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body pb-2">
              <div
                v-if="!lists.recent_companies?.length"
                class="dq-cmd-empty"
              >
                No companies registered in this range
              </div>
              <div
                v-for="company in lists.recent_companies"
                :key="company.id"
                class="dq-cmd-item mb-2"
              >
                <div class="dq-cmd-item__body d-flex align-items-center">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center me-2"
                  >
                    <template v-if="company.logo_url">
                      <img
                        :src="company.logo_url"
                        class="img-fluid w-auto h-auto"
                        alt="logo"
                      />
                    </template>
                    <template v-else>
                      <i class="ti ti-building"></i>
                    </template>
                  </a>
                  <div class="min-width-0">
                    <h6 class="dq-cmd-item__title">{{ company.name }}</h6>
                    <p class="dq-cmd-item__meta">
                      {{ company.plan_label || "No plan" }}
                    </p>
                  </div>
                </div>
                <div class="dq-cmd-item__side">
                  <p class="dq-cmd-item__meta mb-1">{{ company.users }} Users</p>
                  <h6 class="fs-13 fw-normal mb-0">
                    {{ company.domain || "-" }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-4 col-xl-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
            >
              <h5>Recent Plan Expired</h5>
              <router-link
                to="/super-admin/subscription"
                class="btn btn-light btn-sm mb-0"
              >
                View All
              </router-link>
            </div>
            <div class="card-body pb-2">
              <div
                v-if="!lists.recent_expired?.length"
                class="dq-cmd-empty"
              >
                No expired plans in this range
              </div>
              <div
                v-for="exp in lists.recent_expired"
                :key="`expired-list-${exp.id}`"
                class="dq-cmd-item dq-cmd-item--danger mb-2"
              >
                <div class="dq-cmd-item__body d-flex align-items-center">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center me-2"
                  >
                    <i class="ti ti-alert-triangle"></i>
                  </a>
                  <div class="min-width-0">
                    <h6 class="dq-cmd-item__title">
                      {{ exp.company || "Unknown" }}
                    </h6>
                    <p class="dq-cmd-item__meta">Expired : {{ exp.expired_at }}</p>
                  </div>
                </div>
                <div class="dq-cmd-item__side">
                  <a
                    href="javascript:void(0);"
                    class="link-info text-decoration-underline d-block mb-1 fs-13"
                    @click="sendReminder(exp.id)"
                  >
                    Email renewal notice
                  </a>
                  <p class="dq-cmd-item__meta">
                    {{ exp.plan_name }} ({{ exp.billing || "N/A" }})
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";

import { ref, computed, onMounted, watchEffect } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";

import {
  companyChart as baseCompanyChart,
  revenueCharts as baseRevenueCharts,
  donutChart as baseDonutChart,
  totalChart as baseTotalChart,
  activeChart as baseActiveChart,
  inactiveChart as baseInactiveChart,
  locationChart as baseLocationChart,
} from "./data";

import { useSuperAdminDashboardStore } from "@/stores/superAdminDashboardStore";
import { useAuthStore } from "@/stores/authStore";
import subscriptionService from "@/services/super-subscription.service";
import { toast } from "@/utils/toast";

const title = "Dashboard";
const text = "Superadmin";
const text1 = "Dashboard";

const dateRangeInput = ref(null);

// clone chart configs so we can mutate series safely
const companyChart = ref(JSON.parse(JSON.stringify(baseCompanyChart)));
const revenueCharts = ref(JSON.parse(JSON.stringify(baseRevenueCharts)));
const donutChart = ref(JSON.parse(JSON.stringify(baseDonutChart)));
const totalChart = ref(JSON.parse(JSON.stringify(baseTotalChart)));
const activeChart = ref(JSON.parse(JSON.stringify(baseActiveChart)));
const inactiveChart = ref(JSON.parse(JSON.stringify(baseInactiveChart)));
const locationChart = ref(JSON.parse(JSON.stringify(baseLocationChart)));

const dashboard = useSuperAdminDashboardStore();
const authStore = useAuthStore();

const kpis = computed(() => dashboard.kpis || {});
const charts = computed(() => dashboard.charts || {});
const lists = computed(() => dashboard.lists || {});

const pendingReviewCount = computed(
  () => lists.value.pending_reviews?.length || 0
);
const renewalCount = computed(
  () => lists.value.renewal_requests?.length || 0
);
const expiredCount = computed(
  () => lists.value.recent_expired?.length || 0
);
const demoCount = computed(() => lists.value.demo_requests?.length || 0);

function paymentChipClass(status) {
  const value = String(status || "").toLowerCase();
  if (value === "paid") return "dq-cmd-chip--success";
  if (value === "pending" || value === "unpaid") return "dq-cmd-chip--warning";
  if (value === "refunded" || value === "failed") return "dq-cmd-chip--danger";
  return "";
}

const sendingReminderId = ref(null);

const currentUserName = computed(
  () =>
    authStore.user?.first_name ||
    authStore.user?.name ||
    authStore.user?.email ||
    null
);

const rangeLabel = computed(() => {
  const r = dashboard.filters.range;
  if (r === "today") return "Today";
  if (r === "week") return "This Week";
  if (r === "month") return "This Month";
  if (r === "year") return "This Year";
  if (r === "custom") {
    return `${dashboard.filters.date_from} - ${dashboard.filters.date_to}`;
  }
  return "Custom";
});

const yearOptions = computed(() => {
  const current = new Date().getFullYear();
  return [current, current - 1, current - 2];
});

const totalRevenueForYear = computed(() => {
  const rev = charts.value.revenue?.income || [];
  return rev.reduce((sum, v) => sum + (v || 0), 0);
});

const totalRefundsForYear = computed(() => {
  const refunds = charts.value.revenue?.refunds || [];
  return refunds.reduce((sum, v) => sum + (v || 0), 0);
});

const planBreakdownDisplay = computed(() => {
  const labels = charts.value.plans?.labels || [];
  const values = charts.value.plans?.values || [];
  const total = charts.value.plans?.total || 1;

  const colors = ["text-primary", "text-warning", "text-info"];

  return labels.map((label, idx) => ({
    label,
    percent: (((values[idx] || 0) / total) * 100).toFixed(0),
    colorClass: colors[idx] || "text-primary",
  }));
});

// map backend data into chart configs
watchEffect(() => {
  const c = charts.value;

  // KPI small charts
  if (c.cards && Array.isArray(c.cards.total_companies)) {
    totalChart.value.series[0].data = c.cards.total_companies;
  }
  if (c.cards && Array.isArray(c.cards.active_companies)) {
    activeChart.value.series[0].data = c.cards.active_companies;
  }
  if (c.cards && Array.isArray(c.cards.total_subscribers)) {
    inactiveChart.value.series[0].data = c.cards.total_subscribers;
  }
  if (c.cards && Array.isArray(c.cards.total_earnings)) {
    locationChart.value.series[0].data = c.cards.total_earnings;
  }

  // Companies bar chart
  if (c.companies) {
    companyChart.value.series = c.companies.series || companyChart.value.series;
    if (companyChart.value.company?.xaxis) {
      companyChart.value.company.xaxis.categories =
        c.companies.categories || companyChart.value.company.xaxis.categories;
    }
  }

  // Revenue chart
  if (c.revenue) {
    revenueCharts.value.series = [
      { name: "Paid Revenue", data: c.revenue.income || [] },
      { name: "Refunds", data: c.revenue.refunds || [] },
    ];
    if (revenueCharts.value.income?.xaxis) {
      revenueCharts.value.income.xaxis.categories =
        c.revenue.months || revenueCharts.value.income.xaxis.categories;
    }
  }

  // Top plan donut
  if (c.plans) {
    donutChart.value.series = c.plans.values || donutChart.value.series;
    donutChart.value.donut.labels =
      c.plans.labels || donutChart.value.donut.labels;
  }
});

// date range picker
function initDateRangePicker() {
  if (!dateRangeInput.value) return;

  const start = moment().subtract(6, "days");
  const end = moment();

  function cb(startMoment, endMoment) {
    dashboard.setCustomRange(startMoment, endMoment);
  }

  new DateRangePicker(
    dateRangeInput.value,
    {
      startDate: start,
      endDate: end,
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    },
    cb
  );

  cb(start, end); // initial fetch
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function changeRange(range) {
  dashboard.setRange(range);
}

function changeYear(year) {
  dashboard.setYear(year);
}

function formatPercent(val) {
  if (val === null || val === undefined || isNaN(val)) return "0%";
  const num = Number(val);
  const sign = num > 0 ? "+" : "";
  return `${sign}${num.toFixed(2)}%`;
}

function formatCurrency(val) {
  const num = Number(val || 0);
  return `KES ${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

async function sendReminder(subscriptionId) {
  if (!subscriptionId || sendingReminderId.value) return;

  try {
    sendingReminderId.value = subscriptionId;
    await subscriptionService.sendReminder(subscriptionId);
    toast("Renewal notice email sent.", "success");
  } catch (error) {
    toast(
      error?.response?.data?.message || "Failed to send renewal notice email.",
      "error"
    );
  } finally {
    sendingReminderId.value = null;
  }
}

onMounted(() => {
  initDateRangePicker();
});
</script>


